import React from 'react';
import { useIsComerciales } from 'src/feature-app/hooks';
import { LssiTkmQuestionsComerciales, LssiTkmQuestionsTurismos } from '.';

export interface LssiTkmQuestionsProps {
	showTitle: boolean;
	formTheme?: 'main' | 'inverted';
	noCompra?: boolean;
	isComerciales?: boolean;
}

export function LssiTkmQuestions(props: LssiTkmQuestionsProps) {
	const isComerciales = props.isComerciales
		? props.isComerciales
		: useIsComerciales();

	return isComerciales ? (
		<LssiTkmQuestionsComerciales {...props} />
	) : (
		<LssiTkmQuestionsTurismos {...props} />
	);
}
